import React from "react";
import { useSelector } from "react-redux";
import { Divider, Paper, Grid, Box, Hidden } from "@material-ui/core";
import translate from "i18n/translate";
import clabeFormatter from "utils/clabeFormatter";
import { selectUserFullName } from "redux/auth/selectors";
import useStyles from "./speiTransferStyles";
import { CopyButton, Typography } from "../../../common";

const SpeiTransferCard = () => {
  const classes = useStyles();

  const { user } = useSelector(({ auth }) => auth);
  const userFullName = useSelector(({ auth }) => selectUserFullName(auth));

  return (
    <Paper elevation={0} className={classes.card}>
      <Grid container alignItems="center">
        <Grid container item xs={12} alignItems="center">
          <Grid container alignItems="center" justifyContent="space-between">
            <Box
              className={classes.cardContent}
              display="flex"
              flexDirection="column"
            >
              <Box mb={2}>
                <Typography variant="h4Regular">
                  {translate("speiTransfer.content.sc1")}
                  <Hidden smUp>
                    <Box ml={2} display="inline">
                      <CopyButton copy={user.clabe} />
                    </Box>
                  </Hidden>
                </Typography>
              </Box>
              <Typography variant="h3SemiBold">
                {user?.clabe ? (
                  <Box display="flex" alignItems="center">
                    {clabeFormatter(user.clabe)}
                    <Hidden xsDown>
                      <Box ml={2}>
                        <CopyButton copy={user.clabe} />
                      </Box>
                    </Hidden>
                  </Box>
                ) : (
                  "–"
                )}
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Divider className={classes.divider} />
        <Grid container item xs={12} alignItems="center">
          <Box className={classes.cardContent}>
            <Box mb={2}>
              <Typography variant="h4Regular">
                {translate("speiTransfer.content.sc2")}
              </Typography>
            </Box>
            <Typography variant="h3SemiBold">
              {translate("speiTransfer.content.sc2Value")}
            </Typography>
          </Box>
        </Grid>
        <Divider className={classes.divider} />
        <Grid container item xs={12} alignItems="center">
          <Box className={classes.cardContent}>
            <Box mb={2}>
              <Typography variant="h4Regular">
                {translate("speiTransfer.content.sc3")}
              </Typography>
            </Box>
            <Typography variant="h3SemiBold">{userFullName ?? "-"}</Typography>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default SpeiTransferCard;
